import { useMemo } from 'react'

import { UseQueryResult } from '@tanstack/react-query'

import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { GridWidget } from '@fortem-monorepo/react-spa'

import { AnyDataGridBlockOverride, DataGridContentBlock } from '@/components/content-blocks/blocks/data-grid/types'
import { resolveDataGridColumnDefs } from '@/components/content-blocks/blocks/data-grid/utils'
import { ContentBlockRenderContext } from '@/components/content-blocks/context'

export const DataGridBlock: React.FC<{
  block: DataGridContentBlock
  query?: UseQueryResult<any>
  context: ContentBlockRenderContext
  override?: AnyDataGridBlockOverride
}> = ({ query, block, context, override }) => {
  const overrideConfig = useMemo(() => override?.(context, block), [block, context, override])

  const rows = useMemo(() => {
    const sourceRows = block.rows ?? []
    return overrideConfig?.transformRows?.(sourceRows, block) ?? sourceRows
  }, [block, overrideConfig])

  const columnDefs = useMemo(
    () => resolveDataGridColumnDefs(block, overrideConfig?.columnDefs),
    [block, overrideConfig?.columnDefs],
  )

  return (
    <GridWidget title={block.title ?? block.id} query={query}>
      <CustomAgGrid rowData={rows} query={query} columnDefs={columnDefs} {...overrideConfig?.gridProps} />
    </GridWidget>
  )
}
